import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { FileText, Download, Lock } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";

const mb = (n) => `${(n / 1024 / 1024).toFixed(2)} MB`;

export default function DownloadDocs() {
  const { user } = useAuth();
  const [docs, setDocs] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    if (user?.role !== "admin") return;
    api.get("/admin/docs").then((r) => setDocs(r.data)).catch(() => setDocs([]));
  }, [user]);

  if (user && user.role !== "admin") return <Navigate to="/lobby" replace />;

  const download = async (name) => {
    setBusy(name);
    try {
      const r = await api.get(`/admin/docs/${encodeURIComponent(name)}`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = name;
      a.click();
      URL.revokeObjectURL(a.href);
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="min-h-screen bg-base text-white">
      <Navbar />
      <div data-testid="download-docs-page" className="max-w-3xl mx-auto px-4 md:px-8 py-10">
        <div className="flex items-center gap-2 text-signal">
          <Lock className="w-4 h-4" />
          <span className="font-mono text-xs uppercase tracking-widest">Private · admin only</span>
        </div>
        <h1 className="font-heading font-black text-3xl md:text-4xl mt-1 mb-8">Documenti investitori</h1>

        {docs === null && <div className="font-mono text-white/40 text-sm animate-pulse">loading…</div>}
        {docs?.length === 0 && <div data-testid="docs-empty" className="font-mono text-white/40 text-sm">Nessun PDF in /docs</div>}

        <div className="space-y-2">
          {docs?.map((d) => (
            <div key={d.name} data-testid={`doc-row-${d.name}`} className="flex items-center gap-4 bg-panel border border-white/10 rounded-sm px-4 py-3 min-w-0">
              <FileText className="w-5 h-5 text-signal shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="font-mono text-sm truncate">{d.name}</div>
                <div className="text-xs text-white/40 font-mono">{mb(d.size)} · {new Date(d.modified).toLocaleString()}</div>
              </div>
              <button data-testid={`doc-download-${d.name}`} onClick={() => download(d.name)} disabled={busy === d.name}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-mono bg-signal text-black rounded-sm hover:brightness-110 disabled:opacity-50">
                <Download className="w-3.5 h-3.5" /> {busy === d.name ? "…" : "PDF"}
              </button>
            </div>
          ))}
        </div>

        <Link to="/admin/kpi" data-testid="docs-to-kpi" className="inline-block mt-8 text-xs font-mono text-white/50 hover:text-signal">→ KPI Dashboard</Link>
      </div>
    </div>
  );
}
